export interface PlanDetails {
  bigN?: any; // Optional: available after PlanSelector
  reciprocityId?: string; // Optional: set after MemberInfo
  planName?: string; // Optional: set after MemberInfo
}

export interface PlanSelectorState {
  planInfo: Record<string, PlanDetails>;
  setBigN: (planToken: string, bigN: any) => void;
  setPlanInfo: (
    planToken: string,
    coverageTypeReciprocityIdMap: {
      [key: string]: string;
    },
    planName: string,
    population?: string
  ) => void;
  clearPlanInfo: (planContextIds) => void;
}

export enum StoreKeys {
  PLAN_INFO = 'planInfo',
  SET_BIGN = 'setBigN',
  SET_PLAN_INFO = 'setPlanInfo',
  CLEAR_PLANINFO = 'clearPlanInfo',
}

export const initialState: PlanSelectorState = {
  planInfo: {},
  setBigN: () => {},
  setPlanInfo: () => {},
  clearPlanInfo: () => {},
};
